<template>
  <div>
    <nav-title>
      <div slot="rightTool">
        <el-button type="primary" @click="addJSONTPL" v-if="hasAuth('112')">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-cross"></use>
          </svg>
          <span style="margin: 0 5px;">
            添加模板
          </span>
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#icon-picture"></use>
          </svg>
        </el-button>
      </div>
    </nav-title>
    <div class="layout-main">
      <div class="filter">
        <div class="field">
          <el-input
            suffix-icon="el-icon-search"
            class="cl-middle-font-size"
            style="width: 250px"
            size="small"
            v-model="query"
            placeholder="请输入模板名称"
          />
        </div>
        <div class="field">
          <multi-selecter
            :options="videoSizeTags"
            :value.sync="selection"
            label="视频模板尺寸"
          />
        </div>
        <div class="field">
          <el-select
            v-model="type"
            placeholder="视频模板分类"
            size="small"
            clear
          >
            <el-option label="全部" value="0"></el-option>
            <el-option label="JSON模板" value="1"></el-option>
            <el-option label="AE模板" value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="list">
        <list-row :gutter="24" :width="204" v-loading="loading">
          <list-col v-for="(item, index) in list" :key="item.id">
            <div class="item">
              <div class="mask-wrap">
                <div class="content" :style="bg(item)">
                  <div class="mask-item">
                    <div class="button" @click="playVideo(item)">
                      <svg class="svg-icon" aria-hidden="true">
                        <use xlink:href="#icon-preview"></use>
                      </svg>
                    </div>
                    <div
                      class="button"
                      @click="editTemplate(item)"
                      v-if="hasAuth('112')"
                    >
                      <svg class="svg-icon" aria-hidden="true">
                        <use xlink:href="#icon-setting"></use>
                      </svg>
                    </div>
                    <div
                      class="button"
                      @click="createVideo(item)"
                      v-if="hasAuth('111')"
                    >
                      <svg class="svg-icon" aria-hidden="true">
                        <use xlink:href="#icon-edit"></use>
                      </svg>
                    </div>
                    <div
                      class="button"
                      @click="remove(item.id)"
                      v-if="hasAuth('112')"
                    >
                      <svg class="svg-icon" aria-hidden="true">
                        <use xlink:href="#icon-delete"></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="info">
                <edit-in-place
                  :value="list[index].name"
                  @change="updateTextContent(item, $event)"
                />
              </div>
            </div>
          </list-col>
        </list-row>
      </div>
      <div class="pagination">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
      <el-dialog
        class="preview-dialog textAlignCenter"
        title="预览"
        :visible.sync="preview"
      >
        <video class="video" v-if="url" :src="url" autoplay controls />
      </el-dialog>
      <el-dialog
        class="preview-dialog"
        title="保存视频模板"
        :visible.sync="json_tpl"
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="模板名称">
            <el-input v-model="tpl_name"></el-input>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-radio-group
              v-model="tpl_type"
              size="small"
              :disabled="editorDisable"
            >
              <el-radio-button :label="2" :value="2">AE模板</el-radio-button>
              <el-radio-button :label="1" :value="1">JSON模板</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="输入json" v-if="tpl_type === 1">
            <el-input
              type="textarea"
              v-model="json_tpl_content"
              :disabled="editorDisable"
            />
          </el-form-item>
          <el-form-item label="AE name" v-if="tpl_type === 2">
            <el-input
              type="textarea"
              v-model="ae_tpl_name"
              :disabled="editorDisable"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="createTemplate"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- <el-dialog class="preview-dialog" title="添加AE模板" :visible.sync="ae_tpl">
            <div class="field">
                <label>模板名称</label>
                <el-input size="mini" v-model="ae_tpl_name"/>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="createAETemplate"
                           :loading="ae_tpl_loading">确 定</el-button>
              </span>
        </el-dialog>-->
    </div>
  </div>
</template>
<script>
import UploadSvg from 'components/UploadSvg';
import CategorySelect from 'components/CategorySelect';
import { convertJSON } from 'utils/helper';
import notification from '../../utils/notification';
import NavTitle from 'components/NavTitle';
import MultiSelecter from 'components/MultiSelecter';
import _ from 'lodash';
import Row from 'components/List/Row';
import Col from 'components/List/Col';
import ListMixins from 'mixins/list';
import EditInPlace from 'components/EditInPlace';
import { hasAuth } from 'utils/auth';

export default {
  name: 'TemplateList',
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'videoTemplate',
      type: '',
      selection: [],
      url: '',
      preview_url: '',
      ae_tpl_name: '',
      json_tpl_content: '',
      json_tpl: false,
      ae_tpl: false,
      preview: false,
      dialogVisible: false,
      ae_tpl_loading: false,
      editorDisable: false,
      query: '',
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        fileContent: [{ required: true, message: '请上传模板' }]
      },
      form: {
        name: '',
        tagIds: [],
        fileContent: null
      },
      tpl_name: '',
      tpl_type: 1,
      tpl_data: {}
    };
  },
  watch: {
    query() {
      this.queryList();
    },
    type() {
      this.queryList();
    },
    selection() {
      this.queryList();
    },
    dialogVisible(value) {
      if (!value) {
        this.form.name = '';
        this.form.tagIds = [];
        this.form.fileContent = null;
      }
    }
  },
  components: {
    'upload-svg': UploadSvg,
    'category-select': CategorySelect,
    'nav-title': NavTitle,
    'multi-selecter': MultiSelecter,
    'list-row': Row,
    'list-col': Col,
    'edit-in-place': EditInPlace
  },
  mounted() {
    this.handleChangePage(1);
  },
  computed: {
    list() {
      return this.$store.state.videoTemplate.list || [];
    },
    total() {
      return this.$store.state.videoTemplate.total;
    },
    limit() {
      return this.$store.state.videoTemplate.pageSize;
    },
    videoSizeTags() {
      return _.filter(this.$store.state.tags.list, function(o) {
        return o.type === 2;
      });
    }
  },
  beforeDestroy() {
    this.$store.commit('basic/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
    this.$store.commit('videoTemplate/update', {
      condition: {}
    });
  },
  methods: {
    hasAuth(val) {
      return hasAuth(val);
    },
    updateTextContent(item, value) {
      if (value === '') {
        return;
      }
      this.$store
        .dispatch('videoTemplate/create', {
          id: item.id,
          name: value,
          content: item.content,
          type: item.type
        })
        .then(() => {
          this.json_tpl = false;
          this.refreshData();
        });
    },
    editTemplate(data) {
      this.editorDisable = true;
      this.tpl_name = data.name;
      this.tpl_type = data.type;
      this.tpl_data = data;
      if (data.type == 1) {
        this.json_tpl_content = JSON.stringify(data);
      } else {
        this.ae_tpl_name = data.ae_type;
      }
      this.json_tpl = true;
    },
    addJSONTPL() {
      this.tpl_data = {};
      this.tpl_name = '';
      this.tpl_type = 1;
      this.ae_tpl_name = '';
      this.editorDisable = false;
      this.json_tpl = true;
      this.json_tpl_content = '';
    },
    addAETPL() {
      this.ae_tpl_loading = false;
      this.ae_tpl_name = '';
      this.ae_tpl = true;
    },
    playVideo(item) {
      try {
        var res = JSON.parse(item.task_api_response);
      } catch (e) {
        res = { data: {} };
      }
      this.url = res.data.ourOssUr;
      this.preview = true;
    },
    createVideo(item) {
      if (item.type === 1) {
        return this.$router.push('/video/create/?tpl=' + item.id);
      } else if (item.type === 2) {
        return this.$router.push('/ae/create/?tpl=' + item.id);
      }
    },
    createTemplate() {
      if (this.editorDisable) {
        this.updateTextContent(this.tpl_data, this.tpl_name);
      } else if (this.tpl_type === 1) {
        this.importTemplate();
      } else {
        this.createAETemplate();
      }
    },
    createAETemplate() {
      if (this.ae_tpl_loading) return;
      this.json_tpl = false;
      const loading = this.$loading({
        lock: true,
        text: '正在创建, 请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.ae_tpl_name) {
        this.ae_tpl_loading = true;
        this.$store
          .dispatch('videoTemplate/addAE', {
            name: this.ae_tpl_name
          })
          .then(() => {
            this.refreshData();
            this.ae_tpl = false;
            this.ae_tpl_loading = false;
            loading.close();
            this.tpl_name = '';
            this.$nextTick(() => {
              this.$refs['form'].resetFields();
            });
          })
          .catch(() => {
            loading.close();
            this.tpl_name = '';
            this.$nextTick(() => {
              this.$refs['form'].resetFields();
            });
            this.ae_tpl_loading = false;
          });
      } else {
        this.ae_tpl = false;
        this.tpl_name = '';
        this.$nextTick(() => {
          this.$refs['form'].resetFields();
        });
      }
    },
    importTemplate() {
      if (this.json_tpl_content) {
        var data = {};
        try {
          data = JSON.parse(this.json_tpl_content);
        } catch (e) {
          data = {};
          return this.$message.error({
            message: 'JSON解析错误'
          });
        }
        data.generate_video = 1; //生成视频
        if (this.tpl_name) data.name = this.tpl_name;
        this.json_tpl = false;
        const loading = this.$loading({
          lock: true,
          text: '正在创建, 请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$store
          .dispatch('videoTemplate/importTemplate', {
            data
          })
          .then(() => {
            this.refreshData();
            loading.close();
            this.tpl_name = '';
            this.$nextTick(() => {
              this.$refs['form'].resetFields();
            });
          })
          .catch(() => {
            loading.close();
            this.tpl_name = '';
            this.$nextTick(() => {
              this.$refs['form'].resetFields();
            });
          });
      } else {
        this.tpl_name = '';
        this.$nextTick(() => {
          this.$refs['form'].resetFields();
        });
      }
    },
    remove(id) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('videoTemplate/delete', { id }).then(() => {
            this.refreshData();
          });
        })
        .catch();
    },
    queryList() {
      this.$store.commit('videoTemplate/update', {
        page: 1,
        condition: {
          name: this.query || undefined,
          tagIds: _.join(_.map(this.selection, 'id'), ',') || undefined,
          type: this.type
        }
      });
      this.fetchData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    handleSizeChange(pageSize) {
      this.$store.commit('videoTemplate/update', {
        page: 1,
        pageSize
      });
      this.fetchData();
    },
    handleChangePage(page) {
      this.$store.commit('videoTemplate/update', {
        page,
        condition: {
          type: this.type,
          name: this.query,
          tagIds: _.join(_.map(this.selection, 'id'), ',') || undefined
        }
      });
      this.fetchData();
    },
    toggleSelection(id) {
      const index = this.selection.indexOf(id);
      if (index >= 0) {
        this.selection.splice(index, 1);
      } else {
        this.selection.push(id);
      }
    },
    clearSelection() {
      this.selection = [];
    },
    getType(id) {
      return this.selection.indexOf(id) >= 0 ? 'primary' : 'default';
    },
    showUploadDialog() {
      this.dialogVisible = true;
    },
    bg(item) {
      try {
        var res = JSON.parse(item.task_api_response);
      } catch (e) {
        res = { data: {} };
      }
      const url = res.data.snapshoturl;
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      };
    },
    saveTemplateHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$store
            .dispatch('videoTemplate/save', {
              ...this.form,
              filePath: convertJSON(this.form.fileContent),
              tagIds: this.form.tagIds.join(',')
            })
            .then(() => {
              this.refreshData();
              this.dialogVisible = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  > .field {
    margin-right: 8px;
  }
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.cl-pagination {
  padding-bottom: 0;
}

.list {
  padding-top: 20px;
}

.item {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04);
  border: solid 1px #e9edf0;
  .info {
    width: 204px;
    box-sizing: border-box;
    padding: 16px 14px;
    height: 69px;
    display: flex;
    flex-direction: column;
    background: #f4f6f8;
    white-space: nowrap;
    text-align: left;
    flex: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    .size {
      display: inline-block;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.33px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
  .content {
    width: 204px;
    height: 200px;
    overflow: hidden;
    background: #ffffff;
    justify-content: center;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 14px solid white;
    cursor: pointer;
  }
  .name {
    padding: 5px 0;
    text-align: center;
  }
}

.mask-wrap {
  position: relative;
  .mask-item {
    display: none;
    cursor: pointer;
    width: 100%;
    height: 65px;
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0)
    );
    position: absolute;
    bottom: 0;
    z-index: 2000;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 10px;
    .button {
      color: #fff;
      text-align: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.6);
      display: inline-block;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px;
      margin: 0 7px;
      &:hover {
        background: #3fb7ff;
      }
    }
  }
  &:hover {
    .mask-item {
      display: flex;
    }
  }
}
.preview-dialog {
  // text-align: center;
}

.video {
  height: 400px;
  max-width: 100%;
}
.search {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  background: #fff;
  padding: 0 32px 16px 32px;

  > label {
    min-width: 110px;
    color: #555;
    font-size: 14px;
  }
  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .right {
    position: absolute;
    right: 100px;
  }
}
</style>
